import { createHealingIndexQueryForSeriesIdSelector } from "src/selectors/api_selectors/global/healing_index/create_healing_index_query_for_series_id_selector";
import { createSelector } from "reselect";

export function createHealingIndexContextSelector({ seriesId }) {
  return createSelector(
    createHealingIndexQueryForSeriesIdSelector({ seriesId }),
    queries => {
      return queries;
    }
  );
}
